var icon = require('vue-svgicon')
icon.register({
  'ks-icon-bell': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M72.4 97.6a8.4 8.4 0 0 1-16.8 0h16.8M64 22a4.2 4.2 0 0 1 4.2 4.2v4.54a25.23 25.23 0 0 1 21 24.86v25.2l12.6 12.6H26.2l12.6-12.6V55.6a25.23 25.23 0 0 1 21-24.86V26.2A4.2 4.2 0 0 1 64 22z"/>'
  }
})
